const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'templates',
		'core',
		'table',
		'withinFormTable'
	],

	config: {
		buttonContext: 'tripStages',
		showHead: true,
		// showIDs: true,
		showTDVerticalTop: true,
		isSortable: true,
		inline: false,
		// lazyloadStepSize: 10,
		// preventSortOfField: {},
		// sortByDragging: true,
		headRowActions: {
			toggleSortByDragging: {
				show: true,
				turnedOn: false,
			},
		},
		rowActionsInline: true,
		rowActionsProperties: {
			colWidth: '65px',
		},
		rowActions: {
			edit: true,
			customs: [
				{
					buttonType: 'delete',
					neutral: true,
				}
			]
		},
		heartbeatRefreshOn: {
			'reconnect': true,
			'resourceChanged.bosch_tripStages': true,
		},
	},

	model: {
		resourceFilters: {
			order: [{
				fieldCode: 'position',
				direction: 'asc'
			}]
		}
	},

	methods: {

		onBuild(){
			this.config.customHeadActionsFormMapping = {
				buttons: [
					{ buttonType: 'showInsert', context: this.config.buttonContext, positive: true }
				]
			}
		},

		async onConfigSanitized(originalConfig, lastConfig){
			const storage = this.getStorage()
			if(storage.isServer) return;
			if(!this.config.headRowActions.toggleSortByDragging.show) return;

			if(this.config.headRowActions.toggleSortByDragging.prevTurnedOn === undefined) {
				this.config.headRowActions.toggleSortByDragging.prevTurnedOn = this.config.headRowActions.toggleSortByDragging.turnedOn
			} else if (this.config.headRowActions.toggleSortByDragging.prevTurnedOn !== this.config.headRowActions.toggleSortByDragging.turnedOn){
				this.config.headRowActions.toggleSortByDragging.prevTurnedOn = this.config.headRowActions.toggleSortByDragging.turnedOn

				// tweak params for sort mode toggle
				if(this.config.headRowActions.toggleSortByDragging.turnedOn){
					// save and set filters
					this.config.showSortableIndicators = true
					this.model.lastResourceFilters = utils.simpleCopy(this.model.resourceFilters || {})
					this.model.resourceFilters.order = [{
						fieldCode: 'position',
						direction: 'asc'
					}]
					this.model.resourceFilters.offset = 0
					this.model.resourceFilters.limit = 100
				} else {
					// restore filters
					this.model.resourceFilters = utils.simpleCopy(this.model.lastResourceFilters || {})
				}

				// toggle formColCapture
				await this.toggleCaptureFormCol()
			}
		},

		// drag and drop position changed
		selectionChanged(beforeMovingTargetEntity, movingEntity, afterMovingTargetEntity){
			const tripStageID = (movingEntity.attributes || {}).tripStageID
			let beforePosition = ((beforeMovingTargetEntity || {}).attributes || {}).position
			let afterPosition = ((afterMovingTargetEntity || {}).attributes || {}).position

			beforePosition = beforePosition || afterPosition - 1
			afterPosition = afterPosition || beforePosition + 1

			const newPosition = beforePosition + (Math.max(beforePosition, afterPosition) - Math.min(beforePosition, afterPosition)) / 2

			// TODO: MESSGAE
			if(!tripStageID) return;
			if(newPosition <= 0 || Number.isNaN(newPosition)) return;

			return this.performAction(
				this.prepareAction('edit_tripStage', tripStageID, undefined, {
					source: {
						submit: {
							data: {
								data: {
									attributes: {
										position: newPosition
									}
								}
							}
						}
					}
				})
			)
		},

		onHeartbeat(message, heartbeatPrewarmedResourceHashes){
			const refreshers 	= this.config.heartbeatRefreshOn || {}
			const key 			= message.heartbeatKey
			const baseFilters 	= (this.model.parentEntityForTable || {}).baseFilters || {}
			const myTripID 		= baseFilters.tripID

			if(refreshers[key] && (
				(key === 'reconnect') ||
				(key === 'resourceChanged.bosch_tripStages' && myTripID && myTripID == message.data.tripID)
			)){
				this.delayedLastOf('refreshByHeartbeat', () => this.refreshData(true, { refreshResourcesViaHeartbeatKey: key, heartbeatPrewarmedResourceHashes }), 50)
			}
		},
	},
}